import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const suffixMap = {
  relations: '-relations-news',
  impact: '-impact-news',
  interaction: '-interaction-news',
  role: '-role-news',
  sector: '-sector-news',
  intensity: '-intensity-news',
  scope: '-scope-news'
};

const queryParamMap = {
  relations: 'relation',
  impact: 'impact',
  interaction: 'interaction',
  role: 'role',
  sector: 'sector',
  intensity: 'intensity',
  scope: 'scope'
};

/**
 * FilterSlugRedirect
 * ------------------
 * Converts pretty global filter slug URLs (for example,
 * "/global-relations/some-topic") into the equivalent query-parameter
 * variants on the base SPA route, mirroring how the country comparison page
 * works.
 */
export default function FilterSlugRedirect({ kind }) {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    const suffix = suffixMap[kind] || '';
    let value = slug || '';
    const lowerSuffix = suffix.toLowerCase();
    const lowerValue = value.toLowerCase();

    if (lowerSuffix && lowerValue.endsWith(lowerSuffix)) {
      value = value.slice(0, value.length - lowerSuffix.length);
    }

    const queryKey = queryParamMap[kind];
    if (!queryKey || !value) {
      navigate('/', { replace: true });
      return;
    }

    const search = new URLSearchParams();
    search.set(queryKey, value);
    navigate({ pathname: '/', search: `?${search.toString()}` }, { replace: true });
  }, [kind, navigate, slug]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      Redirecting…
    </div>
  );
}
